<div fxLayout="row" fxLayoutAlign="space-between end" class="header-create-section">
    <h2 class="text-xl font-normal leading-normal mt-0 mb-2 font-semibold">Bandeja de Diligencias</h2>
    <button *ngIf="canAdd" (click)="add()" mat-button style="width: fit-content;" color="primary">
        <mat-icon color="primary">add</mat-icon>
        Nuevo registro
    </button>
</div>
<div class="contenedor-filtros" fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap>

</div>

<div style="width: 100% !important;">
    <mat-paginator #paginator [length]="pageService.totalRows" [pageIndex]="pageService.pageIndex"
                   [pageSize]="pageService.pageSize" [pageSizeOptions]="pageService.pageSizeOptions"
                   (page)="changePageHandler($event)">
    </mat-paginator>

    <mat-table class="bandeja-table" #table [dataSource]="dataSource" matSort matSortDisableClear>
        <ng-container matColumnDef="tipo">
            <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" >Tipo
            </mat-header-cell>
            <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                <p class="text-truncate">{{row.tipoTarea}}</p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="asignado">
            <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" >Asignado
            </mat-header-cell>
            <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                <p class="text-truncate">{{row.usuarioAsignado?.label}}</p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="unidad">
            <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" >Unidad
            </mat-header-cell>
            <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                <p class="text-truncate">{{row.organizacion?.label}}</p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="detalle">
            <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" >Detalle
            </mat-header-cell>
            <mat-cell *matCellDef="let row" class="detalles">
                <span>
                    <label><b>Nombre:</b></label>{{row.diligencia.nombreDiligencia}}<br>
                </span>
                <span>
                    <label><b>Folio:</b></label>{{row.diligencia.folio}}<br>
                </span>
                <span>
                    <label><b>Folio del expediente:</b></label>{{row.diligencia.expediente.folio}}<br>
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaCreacion">
            <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" mat-sort-header disableClear>Fecha de creación
            </mat-header-cell>
            <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                <p class="text-truncate">{{row.created | date:'dd/MM/yyyy HH:mm:ss'}}</p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estatus">
            <mat-header-cell *matHeaderCellDef fxLayoutAlign="center center" >Estatus
            </mat-header-cell>
            <mat-cell *matCellDef="let row" fxLayoutAlign="center center">
                <span class="chip {{getThemeClass(row)}}">
                    {{obtenerEstatusActivo(row)}}
                </span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="acciones">
            <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
            <mat-cell *matCellDef="let row">
                <button mat-icon-button [matMenuTriggerFor]="menuAcciones" aria-label="Acciones"
                        (click)="$event.stopPropagation();">
                    <mat-icon>settings</mat-icon>
                </button>
                <mat-menu #menuAcciones="matMenu">
                    <ng-template matMenuContent>
                    <span *ngFor="let opcion of acciones">
                        <button mat-menu-item *ngIf="muestraAccion(row, opcion)"
                                (click)="opcion.accion(row)">{{ opcion.label }}</button>
                    </span>
                    </ng-template>
                </mat-menu>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns; sticky:true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns;" matRipple></mat-row>
    </mat-table>

    <div *ngIf="dataSource.data.length === 0 && pageService.totalRows === 0">
        <div class="message-box ">
            No existen registros.
        </div>
    </div>

    <div *ngIf="dataSource.data.length === 0 && pageService.totalRows > 0">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        Cargando...
    </div>
</div>
